import React from 'react';

import { Modal } from 'src/components/common';
import { ConsumerManageAccountActivityForm } from 'src/components/consumer';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export interface ConsumerManageAccountActivityModalProps {
  consumerId: string;
  onUpdated?: () => void;
}

export const ConsumerManageAccountActivityModal: React.FC<
  ModalV2Props<ConsumerManageAccountActivityModalProps>
> = ({ id, consumerId, onUpdated }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Manage Account Activity"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <ConsumerManageAccountActivityForm
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        consumerId={consumerId}
        onUpdated={onUpdated}
      />
    </Modal>
  );
};
